module.exports = __webpack_public_path__ + "media/images/tiedye/design-8-4c83416d3c5325361635f9cc40952bc9.jpg";